import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { ITimeZone } from './ITimeZone';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class TimeZoneService {
    uri = `${environment.apiLocation}/TimeZone`;
    userTimeZoneUri = `${environment.apiLocation}/UserTimeZone`;
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    public get(): Observable<Array<ITimeZone>> {
        this.log.verbose({
            type: 'TimeZoneService:get',
            uri: this.uri
        });
        return this.http.get<Array<ITimeZone>>(this.uri).pipe(
            map(zones =>
                zones.map(tz => ({
                    ...tz,
                    OffsetMinutes: moment
                        .parseZone(
                            tz.BaseUtcOffset.startsWith('-') ||
                                tz.BaseUtcOffset.startsWith('+')
                                ? tz.BaseUtcOffset
                                : `+${tz.BaseUtcOffset}`,
                            'ZZ'
                        )
                        .utcOffset()
                }))
            ),
            tap(res =>
                this.log.verbose({
                    type: 'TimeZoneService:reponse',
                    res
                })
            )
        );
    }

    public getUserTimeZones(): Observable<Array<ITimeZone>> {
        this.log.verbose({
            type: 'TimeZoneService:getUserTimeZones',
            uri: this.uri
        });
        return this.http.get<Array<ITimeZone>>(this.userTimeZoneUri).pipe(
            map(zones =>
                zones.map(tz => ({
                    ...tz,
                    OffsetMinutes: tz.BaseUtcOffset as unknown as number
                }))
            )
        );
    }
}
